import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentLanguage: "pt-AO",
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state) => {
      state.currentLanguage = "pt-AO";
      localStorage.setItem("app_lang", "pt-AO");
    },
  },
});

export const { setLanguage } = languageSlice.actions;
export default languageSlice.reducer;
